import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import CreatePlan from "./CreatePlan";
import SubscriptionCustom from "./SubscriptionCustom";
import SubscriptionTopUp from "./SubscriptionTopUp";

function AllSubscriptions() {
  return (
    <div className="contentAdmin py-3">
      <Tabs>
        <TabList>
          <Tab>Admin Subscriptions</Tab>
          <Tab>Admin Subscriptions Custom</Tab>
          <Tab>Admin Subscriptions TopUp</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <CreatePlan />
          </TabPanel>
          <TabPanel>
            <SubscriptionCustom />
          </TabPanel>
          <TabPanel>
            <SubscriptionTopUp />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
}

export default AllSubscriptions;
